import { allowedReferrerRedirect, routes } from 'router/routes';
import { BaseClient, FullClient, LanguageCode, PrimaryLanguageEnum, Relationship } from './types';

export const fullName = (client: FullClient): string => {
  return `${client.clientPreferredName || client.clientFirstName} ${client.clientLastName}`;
};

export const clientInitials = (client: BaseClient | FullClient): string => {
  return `${client.clientPreferredName?.slice(0, 1) ?? client.clientFirstName.slice(0, 1)}${client.clientLastName.slice(
    0,
    1,
  )}`;
};

export const requiresIntakeChild = (client: FullClient): boolean => {
  return client.onboardingStatus === 'requires_evaluation_intake_direct_child';
};

export const requiresIntakeAdult = (client: FullClient): boolean => {
  return client.onboardingStatus === 'requires_evaluation_intake_direct_adult';
};

export const getClientRedirect = (client: FullClient | undefined, redirectTo?: string): string => {
  if (client) {
    switch (client.onboardingStatus) {
      case 'requires_evaluation_intake_direct_child':
        return routes.intake.child;

      case 'requires_evaluation_intake_direct_adult':
        return routes.intake.adult;

      case 'ongoing_sessions':
        return allowedReferrerRedirect(redirectTo) || routes.root;

      default:
        throw new Error(`Unhandled onboarding status: ${client.onboardingStatus}!`);
    }
  }

  return allowedReferrerRedirect(redirectTo) || routes.root;
};

export const relationshipOptions: Array<{ label: string; value: Relationship }> = [
  { label: 'Parent', value: 'Parent' },
  { label: 'Client', value: 'Client' },
  { label: 'Dependent', value: 'Dependent' },
  { label: 'Family Member', value: 'Family Member' },
  { label: 'Legal Guardian', value: 'Legal Guardian' },
  { label: 'Physician', value: 'Physician' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Other', value: 'Other' },
];

export const languageOptions: Array<{ label: string; value: LanguageCode }> = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Arabic', value: 'ar' },
  { label: 'French', value: 'fr' },
  { label: 'Korean', value: 'ko' },
  { label: 'Russian', value: 'ru' },
  { label: 'German', value: 'de' },
  { label: 'Haitian Creole', value: 'ht' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Italian', value: 'it' },
  { label: 'Polish', value: 'pl' },
  { label: 'Yiddish', value: 'yi' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Persian', value: 'fa' },
];

export const primaryLanguageOptions: Array<{ label: string; value: LanguageCode }> = Object.entries(
  PrimaryLanguageEnum,
).map(([label, value]) => ({ label, value }));
